import {Component, HostListener} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {CommonService} from "../../../core/services/common.service";
import {HttpClientService} from "../../../core/services/http-client.service";
import {ToastService} from "../../../core/services/toast.service";

@Component({
  selector: 'app-product-filter',
  templateUrl: './product-filter.component.html',
  styleUrls: ['./product-filter.component.css']
})
export class ProductFilterComponent {
  responsiveOptions: any[] | undefined;
  loading: boolean = false;
  noDataLeft: boolean = false;
  currentCategory: any;
  products: any[] = [];
  loader: boolean = false;
  search: boolean = false;
  firstLoaded: boolean = false;
  selectedFilters: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute, private common: CommonService, private http: HttpClientService, private toast: ToastService) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      let q = '';
      if (Array.isArray(params.q)) {
        q = params.q.join(" ").toLowerCase();
      } else if (typeof params.q === 'string') {
        q = params.q.toLowerCase();
      }

      let brand = this.common.brands.find(
        b => q.includes(b.toLowerCase())
      ) || params.brand;
      this.common.obj.limit = parseInt(params.limit) || 15;
      this.common.obj.brand = brand;
      this.common.obj.offset = 0;
      this.common.obj.categoryId = params.categoryId;
      this.common.obj.subCategoryId = params.subCategoryId || 0;
      this.common.obj.q = params.q || "";
      this.currentCategory = params.categoryId
      this.products=[];
      this.noDataLeft = false;
      this.getFofoDeals();
    });
  }

  getFofoDeals() {
    if (this.loader || this.noDataLeft) {
      return;
    }
    this.loader = true;
    this.search = false;
    this.http.get('fofo?'+this.common.stringParams(this.common.obj)).subscribe(data => {
      this.loader = false;
      if (data['responseStatus'].toLowerCase() === 'success') {
        if (this.common.obj.offset == 0) {
          this.products = [];
        }
        for (let f of data['response']) {
          f.selectedNode = 0;
          f.items = f.items.sort((a, b) => a.mop - b.mop);
          this.products.push(f);
        }
        if (data['response'].length > 0) {
          this.common.obj.offset = this.common.obj.offset + this.common.obj.limit;
        } else {
          this.noDataLeft = true;
        }
      } else {
        this.toast.error(data['statusMessage']);
      }
      this.firstLoaded = true;
    }, error => {
      this.loader = false;
      if (error.statusCode == 400) {
        this.toast.error(error.response.message)
      }
      else {
        this.toast.error("Something went wrong")
      }
    });

  }

  @HostListener('window:scroll', [])
  onScroll(): void {
    const scrollHeight = document.documentElement.scrollHeight;
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const clientHeight = document.documentElement.clientHeight;

    if (scrollHeight - scrollTop <= clientHeight + 100) {
      this.getFofoDeals();
    }
  }

  applyFilter(filter: any) {
    this.selectedFilters = filter;
    if ('price' in filter) {
      this.products = this.common.sortByPrice(filter.price, this.products);
    }
  }
}
